import { render, staticRenderFns } from "./CustomerProductTable.vue?vue&type=template&id=b5c45672"
import script from "./CustomerProductTable.vue?vue&type=script&lang=ts"
export * from "./CustomerProductTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports